const services = document.querySelectorAll(".room-service__item");

const removeClassName = async () => {
  services.forEach((service) => {
    service.classList.remove("room-service__item--active");
  });
};

const checkServices = () => {
  const activeServices = document.querySelectorAll(
    ".room-service__item--active"
  );
  if (activeServices.length > 0) {
    services.forEach((service) => {
      service.classList.add("room-service__item--inactive");
    });
  } else {
    services.forEach((service) => {
      service.classList.remove("room-service__item--inactive");
    });
  }
};

services.forEach((service) => {
  service.addEventListener("click", async () => {
    if (!service.classList.contains("room-service__item--active")) {
      await removeClassName();
    }
    service.classList.toggle("room-service__item--active");

    checkServices();
  });
});
